module.exports = __webpack_public_path__ + "img/Makeup4.e4b490d4.jpg";